import { useMediaQuery, useTheme } from '@mui/material'
import { useFlag } from '@unleash/proxy-client-react'
import useSelectedAlbums from '../../hooks/useSelectedAlbums'
import useSelectedMedia from '../../hooks/useSelectedMedia'
import AlbumActionPill from './AlbumActionPill'
import MediaActionPill from './MediaActionPill'
import NavigationPill from './NavigationPill'
import useWebview from '../../hooks/useWebview'

export default function Pill() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const useUpdatedAlbumActions = useFlag('useUpdatedAlbumActions')
  const { selectedModeEnabled: selectedModeEnabledAlbums, selectedAlbums } = useSelectedAlbums()
  const { selectedModeEnabled: selectedModeEnabledMedia, selectedMedia } = useSelectedMedia()
  const { isWebview } = useWebview()
  const isSelectedModeEnabled = selectedModeEnabledAlbums || selectedModeEnabledMedia

  const isAlbumRoute = window.location.pathname.includes('/albums')

  const isTrashRoute = window.location.pathname.includes('/trash')

  if (isTrashRoute || isWebview) {
    return null
  }

  if (!useUpdatedAlbumActions || !isMobile) {
    return <NavigationPill />
  }

  if (isAlbumRoute && isSelectedModeEnabled && selectedAlbums.size > 0) {
    return <AlbumActionPill />
  }

  return isSelectedModeEnabled && selectedMedia.size > 0 ? <MediaActionPill /> : <NavigationPill />
}
